// extracted by mini-css-extract-plugin
export default {"iframe":"IframeModule_iframe__JCvXg","line":"IframeModule_line__7jImS"};